/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HealthScoreResponseModel } from '../../models/health-score-response-model';

export interface ConsumerConsumerHealthScoreGet$Params {
}

export function consumerConsumerHealthScoreGet(http: HttpClient, rootUrl: string, params?: ConsumerConsumerHealthScoreGet$Params, context?: HttpContext): Observable<StrictHttpResponse<HealthScoreResponseModel>> {
  const rb = new RequestBuilder(rootUrl, consumerConsumerHealthScoreGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<HealthScoreResponseModel>;
    })
  );
}

consumerConsumerHealthScoreGet.PATH = '/Consumer/ConsumerHealthScore';
